import { can } from '@kasboek/shared';
import { useActiveLedger } from '../../ledgers/hooks/use-active-ledger';

export function useCanRecord(): boolean {
  const { ledger } = useActiveLedger();
  return ledger ? can(ledger.role, 'transaction:create') : false;
}
